import { createContext } from 'react';

export type DrawerContextValue = {
  activeDrawer: string | null;
  openDrawer: (drawerId: string) => void;
  closeDrawer: () => void;
};

export const DrawerContext = createContext<DrawerContextValue | null>(null);
